import React from 'react';
import {Button, Card, CardActions, CardContent, CardMedia, SvgIcon} from "@material-ui/core";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import { Col, Row } from 'react-bootstrap';
import PDFdoc from '../../../icons/PDFdoc.svg'

const ResourceTile = ({resourceTitle, resourceUrl, resourceAuthor, resourceDescription, resourceImageUrl, createdDate, index}) => {
  const css = useStyles();

  return (
    <Card className={css.card} variant="elevation" onClick={() => window.open(resourceUrl)}>
      <CardMedia
        component="img"
        height="100"
        image={resourceImageUrl || '/Tools/resourceImgForRow.png'}
        alt="Resource Image"
      />
      <CardContent className={`${css.cardContent} pb-2`}>
        <Row className='pr-2'>
          <Col md={11} className="pr-0"><h6 className={'cardTitle'}>{resourceTitle}</h6></Col>
          <Col md={1} className="pl-0 pr-1"><SvgIcon id="PDFdoc-icon" component={PDFdoc} alt={"PDFdoc"} /></Col>
        </Row>

        {/* By <span className={'highlight'}>{resourceAuthor}</span> <br />
        Updated <span className={'highlight'}>{createdDate}</span>
        <p className={'cardDescription'}>{resourceDescription}</p> */}
      </CardContent>
      <CardActions>
        <div className="d-flex justify-content-left">
          <Link to="#" className="link-button">
            <Button color="primary" className='link-btn-padding' variant="text">VIEW RESOURCE</Button>
          </Link>
        </div>
      </CardActions>
    </Card>
  )
}

const useStyles = makeStyles(theme => ({
  card: {
    minHeight: 196,
    width: 262,
    margin: '.5em',
    '& .cardActions': {
      paddingTop: '1em'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  },
  cardContent: {
    '& .highlight': {
      color: theme.palette.primary.main,
      fontWeight: 'bold'
    },
    '& .cardTitle': {
      fontWeight: 'bold'
    },
    '& .cardDescription': {
      color: '#00000099',
      opacity: 1,
      paddingTop: '1em',
      overflow: 'hidden'
    }
  }
}));

export default ResourceTile;


// WEBPACK FOOTER //
// ./src/components/Resource Center/SubComponents/ResourceTile.js